// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9856c7a8","732":"a675a49a","977":"43f83e9a"}[chunkId] + ".chunk.js";
};